import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=44832d06&"
import script from "./Results.vue?vue&type=script&lang=js&"
export * from "./Results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44832d06')) {
      api.createRecord('44832d06', component.options)
    } else {
      api.reload('44832d06', component.options)
    }
    module.hot.accept("./Results.vue?vue&type=template&id=44832d06&", function () {
      api.rerender('44832d06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/Results.vue"
export default component.exports